module.exports = new __parcel__URL__("cardsHubElementThumbnail-dark.db653c30.svg").toString();